import { supabase } from "@/integrations/supabase/client";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const EDGE_FUNCTION_URL = {
  SEND_CODE: `${SUPABASE_URL}/functions/v1/send-verification-code`,
  RESEND_CODE: `${SUPABASE_URL}/functions/v1/resend-verification-code`,
};

export async function signUpWithVerification(email: string, password: string, fullName: string) {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: {
      data: { full_name: fullName },
      emailRedirectTo: `${window.location.origin}/auth`,
    },
  });

  if (error) {
    return { error };
  }

  if (!data.user) {
    return { error: new Error("Falha ao criar usuário") };
  }

  try {
    const { data: sessionData } = await supabase.auth.getSession();
    const token = sessionData.session?.access_token;

    if (!token) {
      throw new Error("Token de autenticação não encontrado");
    }

    const response = await fetch(EDGE_FUNCTION_URL.SEND_CODE, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        email: data.user.email,
        userId: data.user.id,
        fullName,
      }),
    });

    if (!response.ok) {
      throw new Error("Falha ao enviar código de verificação");
    }
  } catch {
    // Signup remains successful even if sending code fails.
  }

  return { error: null };
}

export async function signInWithPassword(email: string, password: string) {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });

  if (error) {
    return { error };
  }

  if (!data.user?.email_confirmed_at) {
    return { error: new Error("Email não verificado. Verifique sua caixa de entrada.") };
  }

  return { error: null };
}

export async function signOutUser() {
  await supabase.auth.signOut();
}

export async function verifyEmailCode(userId: string, code: string) {
  const { data, error } = await supabase.rpc("verify_email_code", {
    p_user_id: userId,
    p_code: code,
  });

  if (error) {
    return { error };
  }

  const rpcData = data as { success: boolean; message?: string };

  if (!rpcData?.success) {
    return { error: new Error(rpcData?.message || "Código inválido") };
  }

  return { error: null };
}

export async function resendVerificationCode(email: string, userId?: string) {
  const { data: sessionData } = await supabase.auth.getSession();
  const token = sessionData.session?.access_token;

  if (!token) {
    return { error: new Error("Não autenticado") };
  }

  const response = await fetch(EDGE_FUNCTION_URL.RESEND_CODE, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ email, userId }),
  });

  if (!response.ok) {
    return { error: new Error("Falha ao reenviar código") };
  }

  return { error: null };
}
